import BatchCreationService from '../../services/BatchCreationService';
import { failedRequest, startRequest } from './GlobalActions';
import { fetchGridFiltersSuccess } from './GridFiltersActions';

export const BatchCreationActions = {
  CASHOUTS_BATCH: 'batch/CASHOUTS_BATCH',
  CASHOUT_CREATE_BATCH: 'batch/CASHOUT_CREATE_BATCH',
};

export const fetchCashoutsBatch = (filters, list) => (dispatch) => {
  dispatch(startRequest({ action: BatchCreationActions.CASHOUTS_BATCH, list }));
  return BatchCreationService.fetchCashoutsBatch(filters).then(
    (batchs) => {
      dispatch(fetchGridFiltersSuccess(list, batchs));
    },
    (error) => {
      dispatch(failedRequest(error, true));
      return { error: true };
    }
  );
};

export const cashoutCreateBatchAction = (data) => async (dispatch) => {
  try {
    return await BatchCreationService.cashoutCreateBatch(data);
  } catch (error) {
    dispatch(failedRequest(error, true));
    return false;
  }
};

export const cashoutCreateFullBatchAction = (data, countryIso) => async (dispatch) => {
  try {
    return await BatchCreationService.cashoutCreateFullBatch(data, countryIso);
  } catch (error) {
    dispatch(failedRequest(error, true));
    return false;
  }
};
